// extracted by mini-css-extract-plugin
export default {"wrapper":"WeChatShare_wrapper__0YAJu","shareImage":"WeChatShare_shareImage__0t2aa","instructions":"WeChatShare_instructions__h82Mw","close":"WeChatShare_close__UAd9G"};